import {ActionTree} from "vuex";
import {IState} from "@/apps/StudyInspiratorWidget/models/store-state-model";
import {IDictionary} from "@/shared/models/interface/dictionary-model";
import {IQuestion} from "@/apps/StudyInspiratorWidget/models/question";

export default <ActionTree<IState, IState>>{
    // Question actions
    orderQuestions({state, commit}) {
        let answers: IDictionary<boolean> = state.localStorageService.read();
        var orderedQuestions: IQuestion[] = state.config.questions;

        // check if there are any answers saved in the local storage
        if (answers) {
            let ids = Object.keys(answers);
            ids.forEach((id, idIndex) => {
                let questionIndex: number = state.config.questions.findIndex(question => question.id == id);

                // if answered question is found put the questions in the same order as the answered questions
                if (idIndex > -1) {
                    let question = orderedQuestions[idIndex];
                    orderedQuestions.splice(questionIndex, 1);
                    orderedQuestions.splice(idIndex, 0, question);
                }
            });

            commit('setCurrentIndex', ids.length);
            commit('setAnswers', answers);
        }

        commit('setQuestions', orderedQuestions);
    },

    setAnswer({state, getters}, answer: boolean) {
        let currentQuestion: IQuestion = getters.currentQuestion;
        state.answers[currentQuestion.id] = answer;

        state.localStorageService.write(state.answers);
    },

    moveForwards({getters, commit}) {
        if (getters.canMoveForwards) {
            commit('moveForwards');
        }
    },

    moveBackwards({getters, commit}) {
        if (getters.canMoveBackwards) {
            commit('moveBackwards');
        }
    },

    restart({state, commit}) {
        commit('setCurrentIndex', 0);
        commit('setAnswers', {});
        commit('setResults', {});
        state.localStorageService.remove();
    },

    loadResults({state, commit, getters}) {
        commit('setLoading', true);

        state.resultsService.getResults(getters.chosenAnswers)
            .then((response) => {
                commit('setResults', response);
            }).catch(error => {
            console.error(error);
        }).finally(() => {
            commit('setLoading', false);
        });
    },

    handleClick({getters, commit}) {
        let isFinished: boolean = getters.isFinished;

        if (isFinished) {
            commit('goToResults');
        } else {
            commit('goToQuestions');
            commit('toggleExplanation');
        }
    }
}
